import $ from 'jquery';
import '../css/common/common.css';
import '../css/common/content-wrapper.css';
import '../css/common/banner-wrapper.css';
import '../css/common/pattern-cover.css';
import '../css/common/section-block.css';

import '../css/image-block.css';

import '../js/importCommonCss';
import setup from './setupCommonJS';
import generateThemeBlock from './theme/generateThemeBlock';
import getThemeList from './request/themeList';
import urlParser from './urlParser';
import hideLoadingImage from './common/hideLoadingImage';

setup();

if (urlParser.branch === 'hualien') {
	getThemeList()
		.then((json) => {
			let blockHtml = '';
			$.each(json.themes, (index, theme) => {
				blockHtml += generateThemeBlock(theme);
			});
			$('.section-block > .content').prepend(blockHtml);
		})
		.then(() => {
			hideLoadingImage();
		});
} else {
	hideLoadingImage();
}



// WEBPACK FOOTER //
// ./src/js/themes.js